<template>
    <div class="rr-box">Pronunciation Test {{ comp.uinfo.ename }}</div>
    <div class="bar"><span>script list</span></div>
    <div class="sample-list">
        <template v-for="(irow, i) in comp.list" :key="i">
            <div class="sample-item" :class="{ 'modified':comp.modified.idx==irow.idx, 'selected':comp.selected.idx==irow.idx }">
                <div class="sample-body">
                    <span class="script" @click="comp.doShow(irow)">{{ irow.script }}</span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import axios from "axios";
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'

export default {
    name: "List",
    components: {
    },
    setup() {
        const toast  = useToast();
        const router = useRouter();
        const store = useStore()

        const comp = reactive({
            audioplayer : null,
            info: {
                text:"",
                status: 0,
                chunks: [],
                mergeURL: null,
                source:null,
                base64: null,
                isnative:false,
            },
            uinfo : { idx:0, ename:'', uid:'' },

            recorder : null,
            list:[], total:0,
            play: { idx:0, vpath:"" },
            selected: { idx:'', native:[], tester:[], control:[] },
            modified: { idx:'', script:'' },

            doSearch: () => {
                let params = {
                    page : comp.page
                }
                axios.get("/ai/sample_list", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.list = res.data.list
                        comp.total = res.data.total
                    } else {
                        toast.error(res.data.err_msg)
                    }
                })
            },

            doShow:(s)=>{
                let idx = s["idx"]
                router.push({ path:`/Front/View/${idx}` })

                comp.uinfo = store.state.user
            },


        });

        onMounted(() => {
            comp.doSearch()
        });

        return { comp };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";

    .rr-box {
        padding:10px 20px; text-align:left; font-size:20px; font-weight:500; color:#333;

        .rr-text {
            width:calc(100% - 50px); float:left;
        }
        .rr-voice {
            width:1px; height:1px; opacity:0.01;
        }
        .btn-send {
            width:40px; height:40px; padding: 3px 10px; margin-top:10px; color: #FFF; border: 1px solid #ddd; border-radius: 50px; background-color: rgb(200, 200, 200); 
            &.active {
                background-color: rgb(122, 134, 238); 
            }
        }
    }
    .bar {
        position:relative; height:20px; padding:10px 0px; border-top:1px solid #c8c8c8; margin:20px 20px 0;
        span {
            position:absolute; top:-10px; left:0; right:0; width:130px; margin:0 auto; text-align:center; background-color:#f9f9f9; color:#999;
        }
    }

    .sample-list {
        padding:0 20px;
        .sample-item {
            position:relative; margin-bottom:5px; border-bottom:1px solid #c8c8c8; padding-bottom:5px;
            .title {
                display:block; text-align:left; height:inherit; color:#929292;
            }
            .sample-body {
                position:relative;
                width:calc(100% - 90px); height:40px; text-align:left; vertical-align:middle;
                display:flex;justify-content: center; align-items: center;
                .script {
                    position:absolute; left:0; vertical-align:middle; cursor:pointer;
                }
                .pronunciation {
                    position:relative; display:none; width:100%; height:40px; text-align:left;
                    .reum-textbox {
                        width:calc(100% - 80px); margin-top:-9px; display:inline-block;
                    }
                }
                button {
                    display:inline-block; width:40px; height:40px; 
                    padding:0; border: 1px solid #ddd; border-radius: 50%;
                    color: #FFF; font-size:1.4rem; text-align:center; margin-top:-1px;
                }
                .btn-submit {
                    background-color:rgb(132, 196, 49);
                }
                .btn-cancel {
                    background-color: rgb(240, 48, 48);
                }
            }
            > button {
                position:absolute; top:0; 
                width:40px; height:40px; padding:0;color: #FFF;
                border: 1px solid #ddd; border-radius: 50%; font-size:1.4rem; text-align:center;
            }
            .btn-play {
                width:30px; height:30px; right:30px; background-color:rgba(177, 214, 129, 0.7);
            }
            .btn-mod {
                display:block; right:42px; background-color:rgba(177, 214, 129, 0.7);
            }
            .btn-demod {
                display:none; right:42px; background-color:rgba(177, 214, 129, 0.7);
            }
            .btn-del {
                right:0px; background-color: rgb(255, 81, 81);
            }
            &.modified {
                .sample-body {
                    // display:block; height:inherit;
                }
                .script {
                    display:none;
                }
                .pronunciation {
                    display:block;
                }
                .voice-list {
                    // display:block;
                }
                .btn-mod {
                    display:none;
                }
                .btn-demod {
                    display:block;
                }
            }
            &.selected {
                .sample-body {
                    display:block; height:inherit;
                }
                .script {
                    position:inherit;
                }
                .pronunciation {
                    // display:block;
                }
                .voice-list {
                    display:block;
                }
                .btn-mod {
                    display:none;
                }
                .btn-demod {
                    display:block;
                }
            }
            &::after {
                display:block; content: ''; clear:both;
            }

            .voice-list {
                padding:10px 0; display:none;
                .phonemes {
                    padding:0px 0 10px;
                }
                .voice-item {
                    background-color:#dfdfdf; display:inline-block; padding:5px; border-radius:30px; margin-right:5px;
                    span {
                        padding:0 10px; cursor:pointer;
                    }
                    button {
                        width:30px; height:30px; padding:0; line-height:28px;
                        i::before {
                            line-height: 28px;;
                        }
                    }
                    .btn-play {
                        background-color:rgba(177, 214, 129, 0.7);
                    }
                    .btn-del {
                        background-color: rgb(255, 81, 81);
                    }
                    label {
                        cursor:pointer;
                    }
                    .checkbox {
                        width:20px; height:20px; margin-right:5px; cursor:pointer;
                    }

                    &.new {
                        .btn-audio {
                            background-color:rgba(177, 214, 129, 0.7);
                        }
                        .btn-rec {
                            background-color: rgb(238, 122, 122);
                        }
                        .btn-send {
                            background-color: rgb(122, 134, 238);
                        }
                    }
                }
            }
        }
    }

</style>
